<template>
  <div class="finished-bank-verification">
    <AppHeader
      border-bottom
      justify-space-between
    />

    <StepContent column>
      <StepIcon
        :img-src="require('@/assets/svg/finished/finished.svg')"
      >
        <h3 class="icon_header">Your work is done! We will contact you soon.</h3>
      </StepIcon>

      <BorrowellBanner
        link="//cdrv.es/3hi"
        datalayer="finished_credit_check_apply"
      />
    </StepContent>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/common/layout/AppHeader'
import AppFooter from '@/components/common/layout/AppFooter'
import StepContent from '@/components/common/step/StepContent'
import StepHeader from '@/components/common/step/StepHeader'
import StepFooter from '@/components/common/step/StepFooter'
import BorrowellBanner from '@/components/common/borrowell/BorrowellBanner'
import StepIcon from '@/components/common/step/StepIcon'

export default {
  // Name
  name: 'BankVerificationFinished',

  // Components
  components: {
    AppHeader,
    AppFooter,
    StepContent,
    StepHeader,
    StepFooter,
    BorrowellBanner,
    StepIcon
  },

  // Mounted
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped lang="scss">
.finished-bank-verification {
  min-height: 100vh;
}

.step-tooltip {
  margin-bottom: 30px;

  @include breakpoint('tablet-portrait-up') {
    margin-top: 0;
  }
}

.step-header {
  padding-bottom: 0;
}

.step-header :deep() {
  .step-header__title {
    color: $theme-text-blue;
  }
}

.step-content {
  margin-bottom: 40px;

  @include breakpoint('tablet-portrait-up') {
    margin-bottom: 50px;
  }
}

.icon_header {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0;
  line-height: 19px;
  color: $theme-text-black;

  @include breakpoint('tablet-portrait-up') {
    font-size: 20px;
  }
}
</style>
